"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('widgets/shared/identity/user/user',["require", "exports", "text!./user.html", "knockout", "messenger", "services/authenticationService", "models/userIdentityModel", "store/tokenStore"], function (require, exports, templateMarkup, ko, messenger, authenticationService, userIdentityModel, tokenStore) {
    "use strict";
    /// <amd-dependency path='text!./user.html' name='templateMarkup' />

    var User = function () {
        function User() {
            _classCallCheck(this, User);

            this.name = userIdentityModel.userName;
            this.isAuthenticated = userIdentityModel.isAuthenticated;
            this.loggingOut = ko.observable(false);
        }

        _createClass(User, [{
            key: "logout",
            value: function logout() {
                var _this = this;

                if (!this.isAuthenticated()) {
                    return;
                }
                this.loggingOut(true);
                authenticationService.logout().then(function () {
                    userIdentityModel.clear();
                    tokenStore.clearAccessToken();
                    messenger.trigger('identity:logout');
                    _this.loggingOut(false);
                });
            }
        }, {
            key: "logoutButtonConfig",
            value: function logoutButtonConfig() {
                var _this2 = this;

                var that = this;
                return {
                    text: 'Logout',
                    type: 'normal',
                    onClick: function onClick(data) {
                        _this2.logout();
                    }
                };
            }
        }]);

        return User;
    }();

    return { viewModel: User, template: templateMarkup };
});
//# sourceMappingURL=user.js.map;
